export default __webpack_public_path__ + "static/media/main_8.c765a632.jpeg";